import { layoutModeTypes } from "constants/layout"
import { format, isValid, parse } from "date-fns"

const mode = "PROD" // SAR, YAMAMA, PROD

const websiteDomain =
  mode === "SAR"
    ? "https://sar-stg.wulooj.com"
    : mode === "YAMAMA"
    ? "https://staging.yamamacrowd.sa"
    : mode === "PROD"
    ? "https://yamamacm.sa"
    : ""
const API_URL =
  mode === "SAR"
    ? "https://sar-stg-app.wulooj.com"
    : mode === "YAMAMA"
    ? "https://sar-stg-app.wulooj.com"
    : // ? "https://staging-api.yamamacrowd.sa"
    mode === "PROD"
    ? "https://api.yamamacm.sa"
    : ""
// const API_URL = "https://stage-sar-api.applligentdemo.com"
// console.log(API_URL)

// const recaptchaSiteJKey = "6LfAfvoqAAAAAIoE6GJA7Aw8Fczw5p0AfusvqXVG"
const recaptchaSiteJKey = "6LefcfsqAAAAABoPWbbUhBba4RQowKbbaGrqDjQY"

const handleFileUpload = (event, setFieldValue, fieldName) => {
  const file = event.target.files[0]
  if (file) {
    setFieldValue(fieldName, file)
  }
}

const getImagePreview = image => {
  if (typeof image === "string") {
    // If image is a string, assume it's a URL and return it directly
    return image
  } else if (image instanceof Blob) {
    // If image is a Blob or File object, create a preview URL
    return URL.createObjectURL(image)
  }
  return null // If neither, return null
}

const convertArabicToNumber = numStr => {
  const arabicDigits = "٠١٢٣٤٥٦٧٨٩"
  const englishDigits = "0123456789"

  return numStr
    .split("")
    .map(char => {
      const index = arabicDigits.indexOf(char)
      return index !== -1 ? englishDigits[index] : char // If Arabic, convert; otherwise, keep the same
    })
    .join("")
}

const arabicEnglishDigitRegex = /^[0-9٠-٩]{9,10}$/
const arabicEnglishDigitRegexTenDigit = /^[0-9٠-٩]{10}$/

const handleStopPropagation = e => {
  e.preventDefault()
  e.stopPropagation()
}

const formatDateForAPI = date => {
  if (!date) return null // Handle empty or undefined date

  const parsedDate =
    typeof date === "string"
      ? parse(date, "yyyy-MM-dd", new Date())
      : new Date(date)

  return isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : null
}

const getLocalizedName = (item, language) => {
  return language === "en" ? item?.name : item?.name_ar
}

const formatDatePayload = (dateStr, toFormat = "dd/MM/yyyy") => {
  if (!dateStr) return "" // Return empty string if no date is provided
  return format(dateStr, "dd/MM/yyyy")
}

const convertTo24Hour = time => {
  try {
    const parsedTime = parse(time, "h:mm a", new Date())

    if (!isValid(parsedTime)) {
      throw new Error("Invalid time format")
    }

    return format(parsedTime, "HH:mm")
  } catch (error) {
    console.error("Error:", error.message)
    return null // Return null or handle it as per your requirement
  }
}

export const handleTableRowColor = (layoutMode, index) => {
  return {
    backgroundColor:
      layoutMode === layoutModeTypes.LIGHT
        ? index % 2 === 0
          ? "white"
          : "#F3F5F6"
        : index % 2 === 0
        ? "#2A3042"
        : "#262B3C",
  }
}

const arabicNameOrNumberPattern = /^[\u0600-\u06FF0-9\s\p{P}\p{S}]+$/u
const englishNameOrNumberPattern = /^[A-Za-z0-9\s\p{P}\p{S}]+$/u

export {
  mode,
  API_URL,
  websiteDomain,
  handleFileUpload,
  getImagePreview,
  convertArabicToNumber,
  arabicEnglishDigitRegex,
  arabicEnglishDigitRegexTenDigit,
  handleStopPropagation,
  formatDateForAPI,
  getLocalizedName,
  formatDatePayload,
  arabicNameOrNumberPattern,
  englishNameOrNumberPattern,
  convertTo24Hour,
  recaptchaSiteJKey,
}
